import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileActionResBody,
  TDeviceProfileActionSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileActionsClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-action', TDeviceProfileActionResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-action', TDeviceProfileActionSummaryResBody> | undefined>;
};

function DeviceProfileActionsClient(apiClient: TAPIClient): TDeviceProfileActionsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-action', TDeviceProfileActionResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-action', TDeviceProfileActionResBody>>(
        `/device-profile-actions/${id}`
      );

      if (data && data.type !== 'device-profile-action') {
        throw new Error('Invalid entity type received, expected: device-profile-action, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-action', TDeviceProfileActionSummaryResBody> | undefined> {
      const data = await apiClient.get<
        TEntityListResponse<'device-profile-action', TDeviceProfileActionSummaryResBody>
      >(`/device-profile-actions?limit=${limit}&page=${page}`);

      if (data && data.type !== 'device-profile-action') {
        throw new Error('Invalid entity type received, expected: device-profile-action, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileActionsClient, DeviceProfileActionsClient };
